// extracted by mini-css-extract-plugin
module.exports = {"loader":"loaders_loader__95Qmt","l3":"loaders_l3__I4pUe"};